import {ReduceStore} from 'flux/utils';
import Immutable from 'immutable';
import Dispatcher from '../dispatcher';

class SearchStore extends ReduceStore {
  getInitialState() {
    return Immutable.List();
  }
  
  getState() {
    return this._state.toJS();
  }

  reduce(state, action) {
    switch (action.type) {
      case 'items/search':
        return Immutable.List(action.search).valueSeq().toArray()
        
      default:
        return state;
    }
  }
  fetchSearch(){
    return this._state;
  }
}

const SearchStoreInstance = new SearchStore(Dispatcher);
export default SearchStoreInstance;